module.exports = __webpack_public_path__ + "static/media/blk-diesel-logo.72aeb92e.png";